import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import { getImpactCalculateVenueCo2ForProject } from './actions/get-impact-calculate-venue-co2-for-project.action';
import { getSummaryImpactCalculateVenueForAllProjects } from './actions/get-summary-impact-calculate-venue-for-all-projects.action';
import { runImpactCalculateVenueCo2ForProject } from './actions/run-impact-calculate-venue-co2-for-project.action';
import { runImpactCalculateVenueEnvForProject } from './actions/run-impact-calculate-venue-env-for-project.action';
import { runImpactCalculateVenueEssForProject } from './actions/run-impact-calculate-venue-ess-for-project.action';
import { CalculateVenue } from './entities/calculate-venue.entity';

export type ImpactCalculateVenueState = {
  isFetching: boolean;
  byProjectId: {
    [projectId: number]: CalculateVenue;
  };
};

const initialState: ImpactCalculateVenueState = {
  isFetching: false,
  byProjectId: {},
};

export const impactCalculateVenueSlice = createSlice({
  name: 'impactCalculateVenue',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      // co2
      .addCase(runImpactCalculateVenueCo2ForProject.fulfilled, () => {
        // in Venue project we do not use the return of this action
        // to get the result we use `getImpactCalculateVenueCo2ForProject`
      })
      // env
      .addCase(
        runImpactCalculateVenueEnvForProject.fulfilled,
        (state, action) => {
          const projectId: number = action.meta.arg.projectId;
          state.byProjectId[projectId] = {
            ...state.byProjectId[projectId],
            env: action.payload.env,
          };
        },
      )
      // ess
      .addCase(
        runImpactCalculateVenueEssForProject.fulfilled,
        (state, action) => {
          const projectId: number = action.meta.arg.projectId;
          state.byProjectId[projectId] = {
            ...state.byProjectId[projectId],
            ess: action.payload.ess,
          };
        },
      )
      // getImpactCalculateVenueCo2ForProject
      .addCase(
        getImpactCalculateVenueCo2ForProject.fulfilled,
        (state, action) => {
          const projectId: number = action.meta.arg.projectId;
          state.byProjectId[projectId] = {
            ...state.byProjectId[projectId],
            ...action.payload,
          };
        },
      )
      // getSummaryImpactCalculateVenueForAllProjects
      .addCase(
        getSummaryImpactCalculateVenueForAllProjects.fulfilled,
        (state, action) => {
          const obj = action.payload.reduce((prev, curr) => {
            return { ...prev, [curr.projectId]: curr.calculate };
          }, {});
          state.byProjectId = obj;
        },
      )
      // isFetching
      .addMatcher(
        isAnyOf(
          runImpactCalculateVenueCo2ForProject.pending,
          runImpactCalculateVenueEnvForProject.pending,
          runImpactCalculateVenueEssForProject.pending,
        ),
        (state) => {
          state.isFetching = true;
        },
      )
      .addMatcher(
        isAnyOf(
          runImpactCalculateVenueCo2ForProject.fulfilled,
          runImpactCalculateVenueEnvForProject.fulfilled,
          runImpactCalculateVenueEssForProject.fulfilled,
        ),
        (state) => {
          state.isFetching = false;
        },
      );
  },
});
